import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import { Grid } from '@mui/material';
import { SCUITextFieldWithSelectBox } from '../../molecules';

import { OrderQuery } from '../../../services/query';

import './SCUIHeaderSearch.scss';

export const SCUIHeaderSearch = () => {
    const [documentType, setDocumentType] = React.useState(1);
    const [orderNo, setOrderNo] = useState('');
    const [searchedText, setSearchedText] = useState('');

    const history = useHistory();
    const { t } = useTranslation();

    const gotoLink = async () => {
        history.replace(' ');
        setTimeout(() => {
            if (orderNo === '') {
                Swal.fire(t('general.pleaseEnterValue'), ' ', 'error');
                return;
            }
            if (documentType === 1) {
                history.push(`/orderdetail?orderNumber=${orderNo}`);
            } else if (documentType === 2) {
                history.push(`/orderdetail?shippingListNo=${orderNo.slice(0, 13)}`);
            } else if (documentType === 3) {
                history.push(`/returnList?RMACode=${orderNo.startsWith('QR_') ? searchedText : orderNo}`);
            } else if (documentType === 4) {
                history.push(`/orders?PhoneNumberbyCustomerId=${orderNo}`);
            } else if (documentType === 5) {
                history.push(`/orders?PhoneNumberbyDelivery=${orderNo}`);
            } else if (documentType === 7) {
                history.push(`/orders?DPackageCargoShipmentCode=${orderNo}&IsDKoli=true`);
            } else if (documentType === 8) {
                history.push(`/orderdetail?trackingCode=${orderNo}`);
            }
        }, 5);
        setOrderNo('');
    };

    const GetOrderIdFromDigitalCardNo = () => {
        let req = { digitalCardNumber: orderNo };
        OrderQuery.GetOrderIdFromDigitalCardNo(req)
            .then((res: any) => {
                if (res.data > 0) {
                    history.replace(' ');
                    setTimeout(() => {
                        history.push(`/orderdetail?orderId=${res.data}`);
                        setOrderNo('');
                    }, 5);
                } else {
                    Swal.fire(t('general.digitalCardNotFound'), ' ', 'error');
                }
            })
            .catch(() => Swal.fire(t('general.failed'), ' ', 'error'));
    };

    useEffect(() => {
        if (orderNo.length > 0) {
            if (orderNo.startsWith('QR_')) {
                const rmaCodeWithoutPrefix = orderNo.substring(3);
                setDocumentType(3);
                localStorage.setItem(
                    'rmaCodeWithQRCode',
                    JSON.stringify({
                        rmaCodeWithoutPrefix: rmaCodeWithoutPrefix,
                        IsQRCodeUse: true,
                    })
                );
                setSearchedText(rmaCodeWithoutPrefix);
            } else if (orderNo.startsWith('2')) {
                setDocumentType(1);
            } else if (orderNo.startsWith('5')) {
                if (orderNo.length === 10) {
                    setDocumentType(4);
                } else {
                    setDocumentType(2);
                }
            } else if (orderNo.startsWith('4')) {
                setDocumentType(3);
            } else if (orderNo.startsWith('6')) {
                setDocumentType(6);
            } else if (orderNo.startsWith('1')) {
                setDocumentType(7);
            }
        }
    }, [orderNo]);

    return (
        <>
            <Grid className="searchedTextHome">
                <SCUITextFieldWithSelectBox
                    defaultText={orderNo}
                    selectList={[
                        { value: 1, text: t('general.orderNumber') },
                        { value: 2, text: t('general.shippingNo') },
                        { value: 3, text: t('customerInformation.returnRequestNo') },
                        { value: 4, text: t('general.customerPhoneNumber') },
                        { value: 5, text: t('general.shippingPhoneNumber') },
                        { value: 6, text: t('orderDetail.digitalCard') },
                        { value: 7, text: t('general.dPackageNo') },
                        { value: 8, text: t('general.mpCargoShipmentNo') },
                    ]}
                    onChangeSelect={(event: any) => {
                        setDocumentType(event.target.value as number);
                    }}
                    selectValue={documentType}
                    onChangeTextField={(event: any) => {
                        setOrderNo(event.target.value.trim());
                    }}
                    onClickButton={() => {
                        if (documentType == 6) {
                            GetOrderIdFromDigitalCardNo();
                        } else {
                            gotoLink();
                        }
                    }}
                    onKeyPressTextField={(e: any) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            if (documentType == 6) {
                                GetOrderIdFromDigitalCardNo();
                            } else {
                                gotoLink();
                            }
                        }
                    }}
                />
            </Grid>
        </>
    );
};
